import type { ResourcesDto } from '@/api/hooks'
import { useResourceTick } from '@/hooks/useResourceTick'
import { ResourceTally } from '@/components/game/ui'

/**
 * Bandeau « banque » compact pour la feuille basse mobile de la carte (<lg,
 * le breakpoint où la colonne latérale desktop disparaît — cf. useIsDesktop).
 * Sur desktop, le header (et son ResourceBanner) reste visible à côté du
 * panneau ; sur mobile la feuille recouvre l'écran, et au moment de charger
 * une cale ou payer un raid le joueur ne voyait plus ses ressources. On
 * réaffiche donc or/bois/rhum DISPONIBLES, avec le même ticker client que le
 * header (useResourceTick) pour rester en phase avec lui. Le collage (sticky
 * + fond opaque) est porté par la coque IslandDetailSheet, via sa prop
 * `header` — ce composant ne rend que la ligne de ressources.
 */
export function SheetResourceBanner({ resources }: { resources: ResourcesDto }) {
  const gold = useResourceTick(resources.gold, resources.goldPerHour, resources.capacity)
  const wood = useResourceTick(resources.wood, resources.woodPerHour, resources.capacity)
  const rum = useResourceTick(resources.rum, resources.rumPerHour, resources.capacity)

  return (
    <div
      data-testid="sheet-resource-banner"
      aria-label="Ressources disponibles"
      className="flex items-center justify-center gap-2.5 px-3 pb-2 text-sm border-b border-sand-500/15"
    >
      <span className="text-[11px] uppercase tracking-wider text-ocean-300">En banque</span>
      <ResourceTally
        gold={gold}
        wood={wood}
        rhum={rum}
        className="text-sand-300 font-medium"
        iconClassName="w-4 h-4 text-sand-300"
      />
    </div>
  )
}
